<template>
  <div class="box">
    <div class="label">{{ title }}</div>
    <div v-if="slots.length === 0" class="empty">{{ emptyText }}</div>
    <div v-else>
      <div v-for="(s, i) in slots" :key="i" class="slot-line">
        <span
          >{{ s.start.slice(0, 5) }}–{{ s.end.slice(0, 5)
          }}<span v-if="s.roomName"> · {{ s.roomName }}</span></span
        >
        <span class="hrs">{{ slotHours(s) }}</span>
      </div>
      <div v-if="footerLabel" class="footer">
        <span>{{ footerLabel }}</span>
        <span class="total">{{ footerValue }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { slotMinutes, formatHoursShort } from "@/utils/workingHoursFormat";

export default {
  name: "ResolvedSlotsBox",
  props: {
    title: { type: String, required: true },
    slots: { type: Array, default: () => [] },
    emptyText: { type: String, default: "ไม่มีตารางวันนี้" },
    footerLabel: { type: String, default: null },
    footerValue: { type: String, default: null },
  },
  methods: {
    slotHours(s) {
      return formatHoursShort(slotMinutes([s]));
    },
  },
};
</script>

<style scoped>
.box {
  background: var(--surface, #fff);
  border: 1px solid var(--line, #e9edf3);
  border-radius: var(--r, 13px);
  padding: 9px 12px;
  box-shadow: var(--shadow-card, 0 1px 2px rgba(60, 70, 90, 0.06));
}
.label {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--faint, #9aa6b6);
  margin-bottom: 6px;
}
.slot-line {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: var(--ink-2, #3f4a5a);
  padding: 3px 0;
  font-family: var(--wh-num, inherit);
  font-variant-numeric: tabular-nums;
}
.empty {
  color: var(--muted, #6c7888);
  font-style: italic;
  font-size: 12.5px;
}
.footer {
  border-top: 1px dashed var(--line-strong, #dde3ec);
  margin-top: 8px;
  padding-top: 7px;
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--muted, #6c7888);
}
.footer .total {
  color: var(--brand-ink, #1d4ed8);
  font-weight: 600;
}
.hrs {
  color: var(--brand, #2563eb);
  font-weight: 600;
}
</style>
